import { React, useState, useEffect } from "react";
import axios from "axios";
const JournalizedBalance = ({
  AccountTransactedID,
  BASE_URL,
  currency_name,
}) => {
  const [journalBalance, setJournalBalance] = useState(0);

  const getJournalBalance = () => {
    axios
      .get(BASE_URL + "/accountListSub/getJournalBalance", {
        params: {
          AccountTransactedID,
        },
      })
      .then((res) => {
        setJournalBalance(res.data || 0);
      });
  };

  useEffect(() => {
    getJournalBalance();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AccountTransactedID, BASE_URL]);

  return (
    <div
      style={{
        fontSize: "0.8rem",
        marginTop: "0.2rem",
        color: "#4b49ac",
        textAlign: "center",
        lineHeight: "1.2",
      }}
    >
      <div
        style={{
          fontSize: "0.7rem",
          color: "#6c757d",
          fontWeight: 500,
        }}
      >
        Journalized Balance
      </div>

      <div
        style={{
          fontSize: "0.9rem",
          fontWeight: 600,
        }}
      >
        {journalBalance.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
          style: "currency",
          currency: currency_name,
        })}
      </div>
    </div>
  );
};

export default JournalizedBalance;
